import { Fragment, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Loading from "components/Loading";
import {
    Modal,
    ModalBody,
    ModalFooter
} from "reactstrap";
import DndMultipleContainers from "components/elements/DndMultipleContainers";
import { exportOrder } from "actions/orderActions";
import { formatterCreateAt } from "components/Function";
import { CSVLink } from "react-csv";

function Modalexportorders(props) {
    const [export_orders_data, setExportOrdersData] = useState([]);
    const [initiateDownload, setInitiateDownload] = useState(false);
    const btnRef = useRef(null);
    const [leftItems, setLeftItems] = useState([]);
    const [rightItems, setRightItems] = useState([]);
    const [timezone, setTimezone] = useState("Asia/Ho_Chi_Minh");

    var { isLoading, all_orders_for_export } = props.order;
    var { isOpenModalExportOrders, openModal, formatterCreateAt, orders_selected, list_staff, exportOrder } = props;
    const { t } = useTranslation();
    
    useEffect(() => {
        var export_orders_columns = localStorage.getItem("export_orders_columns");
        if (export_orders_columns) {
            setLeftItems(JSON.parse(export_orders_columns)?.left_items);
            setRightItems(JSON.parse(export_orders_columns)?.right_items);
            setTimezone(JSON.parse(export_orders_columns)?.timezone);
        } else {
            setLeftItems([
                { id: "fulfill_note", label: "fulfill_note" },
                { id: "printer", label: "printer" },
                { id: "fulfillment_order_id", label: "fulfillment_order_id" },
                { id: "base_cost", label: "base_cost" },
                { id: "design_fee", label: "design_fee" },
            ]);
            setRightItems([
                { id: "id", label: "id" },
                { id: "status", label: "status" },
                { id: "title", label: "title" },
                { id: "main_images", label: "main_images" },
                { id: "image", label: "image" },
                { id: "design_front", label: "design_front" },
                { id: "design_back", label: "design_back" },
                { id: "design_neck", label: "design_neck" },
                { id: "design_right", label: "design_right" },
                { id: "design_left", label: "design_left" },
                { id: "design_aop_3d", label: "design_aop_3d" },
                { id: "mockup_front", label: "mockup_front" },
                { id: "mockup_back", label: "mockup_back" },
                { id: "mockup_neck", label: "mockup_neck" },
                { id: "mockup_right", label: "mockup_right" },
                { id: "mockup_left", label: "mockup_left" },
                { id: "mockup_aop_3d", label: "mockup_aop_3d" },
                { id: "skus", label: "skus" },
                { id: "seller_sku", label: "seller_sku" },
                { id: "label", label: "label" },
                { id: "tracking_number", label: "tracking_number" },
                { id: "price", label: "price" },
                { id: "est", label: "est" },
                { id: "name", label: "name" },
                { id: "address", label: "address" },
                { id: "phone", label: "phone" },
                { id: "buyer_note", label: "buyer_note" },
                { id: "shop_name", label: "shop_name" },
                { id: "shop_note", label: "shop_note" },
                { id: "email_member", label: "email_member" },
                { id: "create_time", label: "create_time" },
            ]);
            setTimezone("Asia/Ho_Chi_Minh");
        }
    }, []);
    
    useEffect(() => {
        if (all_orders_for_export.length > 0) {
            var export_orders_data = [];
            for (var i = 0; i < all_orders_for_export.length; i++) {
                if (orders_selected.length > 0) {
                    if (!orders_selected.includes(all_orders_for_export[i]._id)) {
                        continue;
                    }
                }
                for (var j = 0; j < all_orders_for_export[i]?.line_items.length; j++) {
                    var export_orders_data_tmp = {
                        id: "'" + all_orders_for_export[i]?.apiOrderId,
                        status: all_orders_for_export[i]?.status,
                        title: all_orders_for_export[i]?.line_items[j]?.product_name,
                        main_images: all_orders_for_export[i]?.line_items[j]?.main_images.join("|"),
                        image: all_orders_for_export[i]?.line_items[j]?.sku_image,
                        design_front: all_orders_for_export[i]?.design?.[all_orders_for_export[i]?.line_items[j]?.id]?.Front || "",
                        design_back: all_orders_for_export[i]?.design?.[all_orders_for_export[i]?.line_items[j]?.id]?.Back || "",
                        design_neck: all_orders_for_export[i]?.design?.[all_orders_for_export[i]?.line_items[j]?.id]?.Neck || "",
                        design_right: all_orders_for_export[i]?.design?.[all_orders_for_export[i]?.line_items[j]?.id]?.Right || "",
                        design_left: all_orders_for_export[i]?.design?.[all_orders_for_export[i]?.line_items[j]?.id]?.Left || "",
                        design_aop_3d: all_orders_for_export[i]?.design?.[all_orders_for_export[i]?.line_items[j]?.id]?.AOP_3D || "",
                        mockup_front: all_orders_for_export[i]?.mockup?.[all_orders_for_export[i]?.line_items[j]?.id]?.Front || "",
                        mockup_back: all_orders_for_export[i]?.mockup?.[all_orders_for_export[i]?.line_items[j]?.id]?.Back || "",
                        mockup_neck: all_orders_for_export[i]?.mockup?.[all_orders_for_export[i]?.line_items[j]?.id]?.Neck || "",
                        mockup_right: all_orders_for_export[i]?.mockup?.[all_orders_for_export[i]?.line_items[j]?.id]?.Right || "",
                        mockup_left: all_orders_for_export[i]?.mockup?.[all_orders_for_export[i]?.line_items[j]?.id]?.Left || "",
                        mockup_aop_3d: all_orders_for_export[i]?.mockup?.[all_orders_for_export[i]?.line_items[j]?.id]?.AOP_3D || "",
                        skus: all_orders_for_export[i]?.line_items[j]?.sku_name,
                        seller_sku: all_orders_for_export[i]?.line_items[j]?.seller_sku,
                        label: all_orders_for_export[i]?.shipping_label,
                        tracking_number: "'" + all_orders_for_export[i]?.tracking_number,
                        price: j === 0 ? all_orders_for_export[i]?.payment.total_amount : "0",
                        est: j === 0 ? all_orders_for_export[i]?.shipping_type === "TIKTOK" ? (((+all_orders_for_export[i]?.payment?.original_total_product_price - +all_orders_for_export[i]?.payment?.seller_discount) - 6 / 100 * (+all_orders_for_export[i]?.payment?.total_amount + +all_orders_for_export[i]?.payment?.platform_discount - +all_orders_for_export[i]?.payment?.tax)).toFixed(2)) : ((+all_orders_for_export[i]?.payment?.original_total_product_price - +all_orders_for_export[i]?.payment?.seller_discount + +all_orders_for_export[i]?.payment?.shipping_fee) - 6 / 100 * (+all_orders_for_export[i]?.payment?.total_amount + +all_orders_for_export[i]?.payment?.platform_discount - +all_orders_for_export[i]?.payment?.tax)).toFixed(2) : "0",
                        name: all_orders_for_export[i]?.recipient_address.name,
                        address: all_orders_for_export[i]?.recipient_address?.address_detail + "," + (all_orders_for_export[i].recipient_address?.address_line2 ? all_orders_for_export[i].recipient_address?.address_line2 + ", " : "") + (all_orders_for_export[i].recipient_address?.district_info?.[3]?.address_name ? all_orders_for_export[i].recipient_address?.district_info?.[3]?.address_name + ", " : "") + (all_orders_for_export[i].recipient_address?.district_info?.[2]?.address_name && all_orders_for_export[i].recipient_address?.district_info?.[2]?.address_level_name !== "County" ? all_orders_for_export[i].recipient_address?.district_info?.[2]?.address_name + ", " : "") + (all_orders_for_export[i].recipient_address?.district_info?.[1]?.address_name ? all_orders_for_export[i].recipient_address?.district_info?.[1]?.address_name + ", " : "") + (all_orders_for_export[i].recipient_address?.district_info?.[0]?.address_name ? all_orders_for_export[i].recipient_address?.district_info?.[0]?.address_name + ", " : "") + (all_orders_for_export[i].recipient_address?.postal_code ? all_orders_for_export[i].recipient_address?.postal_code : ""),
                        phone: all_orders_for_export[i]?.recipient_address.phone_number,
                        buyer_note: all_orders_for_export[i]?.buyer_message,
                        shop_name: all_orders_for_export[i]?.shops?.name,
                        shop_note: all_orders_for_export[i]?.shops?.note,
                        email_member: list_staff?.find((v, i) => v?.value === all_orders_for_export[i]?.createdBy)?.label,
                        create_time: formatterCreateAt(all_orders_for_export[i]?.create_time * 1000, "full", timezone),
                        fulfill_note: all_orders_for_export[i]?.keywords,
                        printer: all_orders_for_export[i]?.printer ? Object.values(all_orders_for_export[i]?.printer)?.[0]?.printer || "" : "",
                        fulfillment_order_id: all_orders_for_export[i]?.fulfillment_order_id,
                        base_cost: all_orders_for_export[i]?.base_cost || "0",
                        design_fee: all_orders_for_export[i]?.design_fee ? Object.values(all_orders_for_export[i]?.design_fee).reduce((a, b) => +a + +b, 0) : "0",
                    }
                    for (var k = 0; k < leftItems.length; k++) {
                        delete export_orders_data_tmp[leftItems[k].id];
                    }
                    const sortedData = {};
                    for (var l = 0; l < rightItems.length; l++) {
                        const key = rightItems[l].id;
                        if (export_orders_data_tmp.hasOwnProperty(key)) {
                            sortedData[key] = export_orders_data_tmp[key];
                        }
                    }
                    export_orders_data.push(sortedData);
                }
            }
            setExportOrdersData(export_orders_data);
            setInitiateDownload(true);
        }
    }, [all_orders_for_export, formatterCreateAt]); // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => {
        setInitiateDownload(false);
        if (initiateDownload) {
            btnRef.current?.click();
        }
    }, [initiateDownload]);

    const onClickExportOrders = () => {
        localStorage.setItem("export_orders_columns", JSON.stringify({ left_items: leftItems, right_items: rightItems, timezone }));
        exportOrder(props.exportorders.searchText + "|cotik|" + orders_selected.join(","), props.exportorders.filter_printer, props.exportorders.filter_shop_code, props.exportorders.filter_status, props.exportorders.filter_work_status, props.exportorders.filter_staff, props.exportorders.filter_order_design, props.exportorders.dateStart_tmp, props.exportorders.dateEnd_tmp);
    }

    const onClickResetDefault = () => {
        setLeftItems([
            { id: "fulfill_note", label: "fulfill_note" },
            { id: "printer", label: "printer" },
            { id: "fulfillment_order_id", label: "fulfillment_order_id" },
            { id: "base_cost", label: "base_cost" },
            { id: "design_fee", label: "design_fee" },
        ]);
        setRightItems([
            { id: "id", label: "id" },
            { id: "status", label: "status" },
            { id: "title", label: "title" },
            { id: "main_images", label: "main_images" },
            { id: "image", label: "image" },
            { id: "design_front", label: "design_front" },
            { id: "design_back", label: "design_back" },
            { id: "design_neck", label: "design_neck" },
            { id: "design_right", label: "design_right" },
            { id: "design_left", label: "design_left" },
            { id: "design_aop_3d", label: "design_aop_3d" },
            { id: "mockup_front", label: "mockup_front" },
            { id: "mockup_back", label: "mockup_back" },
            { id: "mockup_neck", label: "mockup_neck" },
            { id: "mockup_right", label: "mockup_right" },
            { id: "mockup_left", label: "mockup_left" },
            { id: "mockup_aop_3d", label: "mockup_aop_3d" },
            { id: "skus", label: "skus" },
            { id: "seller_sku", label: "seller_sku" },
            { id: "label", label: "label" },
            { id: "tracking_number", label: "tracking_number" },
            { id: "price", label: "price" },
            { id: "est", label: "est" },
            { id: "name", label: "name" },
            { id: "address", label: "address" },
            { id: "phone", label: "phone" },
            { id: "buyer_note", label: "buyer_note" },
            { id: "shop_name", label: "shop_name" },
            { id: "shop_note", label: "shop_note" },
            { id: "email_member", label: "email_member" },
            { id: "create_time", label: "create_time" },
        ]);
        setTimezone("Asia/Ho_Chi_Minh");
    };

    const onChange = (e) => {
        if (e.target.name === "timezone") {
            setTimezone(e.target.value);
        }
    }

    const onOpenModal = () => {
        openModal();
    };

    return (
        <Fragment>
            <Modal centered={true} size="lg" toggle={() => { onOpenModal() }} isOpen={isOpenModalExportOrders}>
                <Loading isLoading={isLoading} />
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Export Orders")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i className="ki-outline ki-cross fs-1" onClick={() => { onOpenModal() }} ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="row">
                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container col-8">
                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                <span className="">{t("Timezone for create_time")}</span>
                            </label>
                            <select name="timezone" value={timezone} className="form-select form-select-solid form-select-lg fw-semibold" onChange={(e) => { onChange(e) }} >
                                <option value="" data-value="">
                                    Select a default time zone ...{" "}
                                </option>
                                <option value="Etc/GMT+12" data-value="-12">
                                    (GMT-12:00) International Date Line West
                                </option>
                                <option value="Pacific/Midway" data-value="-11">
                                    (GMT-11:00) Midway Island, Samoa
                                </option>
                                <option value="Pacific/Honolulu" data-value="-10">
                                    (GMT-10:00) Hawaii
                                </option>
                                <option value="US/Alaska" data-value="-9">
                                    (GMT-09:00) Alaska
                                </option>
                                <option value="America/Los_Angeles" data-value="-8">
                                    (GMT-08:00) Pacific Time (US & Canada)
                                </option>
                                <option value="America/Tijuana" data-value="-8">
                                    (GMT-08:00) Tijuana, Baja California
                                </option>
                                <option value="US/Arizona" data-value="-7">
                                    (GMT-07:00) Arizona
                                </option>
                                <option value="America/Chihuahua" data-value="-7">
                                    (GMT-07:00) Chihuahua, La Paz, Mazatlan
                                </option>
                                <option value="US/Mountain" data-value="-7">
                                    (GMT-07:00) Mountain Time (US & Canada)
                                </option>
                                <option value="America/Managua" data-value="-6">
                                    (GMT-06:00) Central America
                                </option>
                                <option value="US/Central" data-value="-6">
                                    (GMT-06:00) Central Time (US & Canada)
                                </option>
                                <option value="America/Mexico_City" data-value="-6">
                                    (GMT-06:00) Guadalajara, Mexico City, Monterrey
                                </option>
                                <option value="Canada/Saskatchewan" data-value="-6">
                                    (GMT-06:00) Saskatchewan
                                </option>
                                <option value="America/Bogota" data-value="-5">
                                    (GMT-05:00) Bogota, Lima, Quito, Rio Branco
                                </option>
                                <option value="US/Eastern" data-value="-5">
                                    (GMT-05:00) Eastern Time (US & Canada)
                                </option>
                                <option value="US/East-Indiana" data-value="-5">
                                    (GMT-05:00) Indiana (East)
                                </option>
                                <option value="Canada/Atlantic" data-value="-4">
                                    (GMT-04:00) Atlantic Time (Canada)
                                </option>
                                <option value="America/Caracas" data-value="-4">
                                    (GMT-04:00) Caracas, La Paz
                                </option>
                                <option value="America/Manaus" data-value="-4">
                                    (GMT-04:00) Manaus
                                </option>
                                <option value="America/Santiago" data-value="-4">
                                    (GMT-04:00) Santiago
                                </option>
                                <option value="Canada/Newfoundland" data-value="-3.5">
                                    (GMT-03:30) Newfoundland
                                </option>
                                <option value="America/Sao_Paulo" data-value="-3">
                                    (GMT-03:00) Brasilia
                                </option>
                                <option value="America/Argentina/Buenos_Aires" data-value="-3">
                                    (GMT-03:00) Buenos Aires, Georgetown
                                </option>
                                <option value="America/Godthab" data-value="-3">
                                    (GMT-03:00) Greenland
                                </option>
                                <option value="America/Montevideo" data-value="-3">
                                    (GMT-03:00) Montevideo
                                </option>
                                <option value="America/Noronha" data-value="-2">
                                    (GMT-02:00) Mid-Atlantic
                                </option>
                                <option value="Atlantic/Cape_Verde" data-value="-1">
                                    (GMT-01:00) Cape Verde Is.
                                </option>
                                <option value="Atlantic/Azores" data-value="-1">
                                    (GMT-01:00) Azores
                                </option>
                                <option value="Africa/Casablanca" data-value="0">
                                    (GMT+00:00) Casablanca, Monrovia, Reykjavik
                                </option>
                                <option value="Etc/Greenwich" data-value="0">
                                    (GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London
                                </option>
                                <option value="Europe/Amsterdam" data-value="1">
                                    (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna
                                </option>
                                <option value="Europe/Belgrade" data-value="1">
                                    (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague
                                </option>
                                <option value="Europe/Brussels" data-value="1">
                                    (GMT+01:00) Brussels, Copenhagen, Madrid, Paris
                                </option>
                                <option value="Europe/Sarajevo" data-value="1">
                                    (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb
                                </option>
                                <option value="Africa/Lagos" data-value="1">
                                    (GMT+01:00) West Central Africa
                                </option>
                                <option value="Asia/Amman" data-value="2">
                                    (GMT+02:00) Amman
                                </option>
                                <option value="Europe/Athens" data-value="2">
                                    (GMT+02:00) Athens, Bucharest, Istanbul
                                </option>
                                <option value="Asia/Beirut" data-value="2">
                                    (GMT+02:00) Beirut
                                </option>
                                <option value="Africa/Cairo" data-value="2">
                                    (GMT+02:00) Cairo
                                </option>
                                <option value="Africa/Harare" data-value="2">
                                    (GMT+02:00) Harare, Pretoria
                                </option>
                                <option value="Europe/Helsinki" data-value="2">
                                    (GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius
                                </option>
                                <option value="Asia/Jerusalem" data-value="2">
                                    (GMT+02:00) Jerusalem
                                </option>
                                <option value="Europe/Minsk" data-value="2">
                                    (GMT+02:00) Minsk
                                </option>
                                <option value="Africa/Windhoek" data-value="2">
                                    (GMT+02:00) Windhoek
                                </option>
                                <option value="Asia/Kuwait" data-value="3">
                                    (GMT+03:00) Kuwait, Riyadh, Baghdad
                                </option>
                                <option value="Europe/Moscow" data-value="3">
                                    (GMT+03:00) Moscow, St. Petersburg, Volgograd
                                </option>
                                <option value="Africa/Nairobi" data-value="3">
                                    (GMT+03:00) Nairobi
                                </option>
                                <option value="Asia/Tbilisi" data-value="3">
                                    (GMT+03:00) Tbilisi
                                </option>
                                <option value="Asia/Tehran" data-value="3.5">
                                    (GMT+03:30) Tehran
                                </option>
                                <option value="Asia/Muscat" data-value="4">
                                    (GMT+04:00) Abu Dhabi, Muscat
                                </option>
                                <option value="Asia/Baku" data-value="4">
                                    (GMT+04:00) Baku
                                </option>
                                <option value="Asia/Yerevan" data-value="4">
                                    (GMT+04:00) Yerevan
                                </option>
                                <option value="Asia/Kabul" data-value="4.5">
                                    (GMT+04:30) Kabul
                                </option>
                                <option value="Asia/Yekaterinburg" data-value="5">
                                    (GMT+05:00) Yekaterinburg
                                </option>
                                <option value="Asia/Karachi" data-value="5">
                                    (GMT+05:00) Islamabad, Karachi, Tashkent
                                </option>
                                <option value="Asia/Calcutta" data-value="5.5">
                                    (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi
                                </option>
                                <option value="Asia/Calcutta" data-value="5.5">
                                    (GMT+05:30) Sri Jayawardenapura
                                </option>
                                <option value="Asia/Katmandu" data-value="5.75">
                                    (GMT+05:45) Kathmandu
                                </option>
                                <option value="Asia/Almaty" data-value="6">
                                    (GMT+06:00) Almaty, Novosibirsk
                                </option>
                                <option value="Asia/Dhaka" data-value="6">
                                    (GMT+06:00) Astana, Dhaka
                                </option>
                                <option value="Asia/Rangoon" data-value="6.5">
                                    (GMT+06:30) Yangon (Rangoon)
                                </option>
                                <option value="Asia/Bangkok" data-value="7">
                                    (GMT+07:00) Bangkok, Hanoi, Jakarta
                                </option>
                                <option value="Asia/Krasnoyarsk" data-value="7">
                                    (GMT+07:00) Krasnoyarsk
                                </option>
                                <option value="Asia/Hong_Kong" data-value="8">
                                    (GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi
                                </option>
                                <option value="Asia/Kuala_Lumpur" data-value="8">
                                    (GMT+08:00) Kuala Lumpur, Singapore
                                </option>
                                <option value="Asia/Irkutsk" data-value="8">
                                    (GMT+08:00) Irkutsk, Ulaan Bataar
                                </option>
                                <option value="Australia/Perth" data-value="8">
                                    (GMT+08:00) Perth
                                </option>
                                <option value="Asia/Taipei" data-value="8">
                                    (GMT+08:00) Taipei
                                </option>
                                <option value="Asia/Tokyo" data-value="9">
                                    (GMT+09:00) Osaka, Sapporo, Tokyo
                                </option>
                                <option value="Asia/Seoul" data-value="9">
                                    (GMT+09:00) Seoul
                                </option>
                                <option value="Asia/Yakutsk" data-value="9">
                                    (GMT+09:00) Yakutsk
                                </option>
                                <option value="Australia/Adelaide" data-value="9.5">
                                    (GMT+09:30) Adelaide
                                </option>
                                <option value="Australia/Darwin" data-value="9.5">
                                    (GMT+09:30) Darwin
                                </option>
                                <option value="Australia/Brisbane" data-value="10">
                                    (GMT+10:00) Brisbane
                                </option>
                                <option value="Australia/Canberra" data-value="10">
                                    (GMT+10:00) Canberra, Melbourne, Sydney
                                </option>
                                <option value="Australia/Hobart" data-value="10">
                                    (GMT+10:00) Hobart
                                </option>
                                <option value="Pacific/Guam" data-value="10">
                                    (GMT+10:00) Guam, Port Moresby
                                </option>
                                <option value="Asia/Vladivostok" data-value="10">
                                    (GMT+10:00) Vladivostok
                                </option>
                                <option value="Asia/Magadan" data-value="11">
                                    (GMT+11:00) Magadan, Solomon Is., New Caledonia
                                </option>
                                <option value="Pacific/Auckland" data-value="12">
                                    (GMT+12:00) Auckland, Wellington
                                </option>
                                <option value="Pacific/Fiji" data-value="12">
                                    (GMT+12:00) Fiji, Kamchatka, Marshall Is.
                                </option>
                                <option value="Pacific/Tongatapu" data-value="13">
                                    (GMT+13:00) Nuku'alofa
                                </option>
                            </select>
                        </div>
                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container col-4">
                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                <span>&nbsp;</span>
                            </label>
                            <button onClick={() => { onClickResetDefault() }} type="button" className="btn btn-primary">
                                {t("Reset default")}
                            </button>
                        </div>
                    </div>
                    <DndMultipleContainers leftItems={leftItems} setLeftItems={setLeftItems} rightItems={rightItems} setRightItems={setRightItems} />
                </ModalBody>
                <ModalFooter>
                    <button type="reset" id="kt_modal_users_search_reset" data-bs-dismiss="modal" className="btn btn-active-light me-3" onClick={() => { onOpenModal() }} >{t("Cancel")}</button>
                    <button onClick={() => { onClickExportOrders() }} type="button" className="btn btn-primary me-3">
                        {t("Export")}
                    </button>
                    <CSVLink filename={"orders_" + formatterCreateAt((new Date()).getTime(), "dmy", "Asia/Ho_Chi_Minh") + ".csv"} data={export_orders_data}>
                        <span ref={btnRef} />
                    </CSVLink>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

Modalexportorders.propTypes = {
    formatterCreateAt: PropTypes.func.isRequired,
    exportOrder: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
    order: state.order
});
const mapDispatchToProps = {
    formatterCreateAt,
    exportOrder
}

export default connect(mapStateToProps, mapDispatchToProps)(Modalexportorders);